import {Action} from "redux-actions";
import {ORGANIZATION_FETCHED} from "./actionType";
import {OnFailure, OnSuccess, OnSuccessData} from "../actionHelpers";
import {Dispatch} from "redux";
import {api} from "../../../api/api";
import Organization from "../../../model/organization/Organization";

/**
 * Organization data fetched successful action.
 * @return {Action<ORGANIZATION_FETCHED>}
 * @param organization
 */
function organizationFetched(organization: Organization): Action<ORGANIZATION_FETCHED> {
	return {type: ORGANIZATION_FETCHED, payload: {organization}}
}

/**
 * Fetch organization data.
 * @param {OnSuccess} onSuccess
 * @param {OnFailure} onFailure
 */
export function fetchOrganization(onSuccess: OnSuccessData<Organization>, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.organizationApi.fetchOrganization().then(organization => {
			dispatch(organizationFetched(organization));
			onSuccess(organization);
		}).catch(onFailure);
	}
}
